import { render, staticRenderFns } from "./DriverIndicationStatuses.vue?vue&type=template&id=5c04265e&"
import script from "./DriverIndicationStatuses.vue?vue&type=script&lang=js&"
export * from "./DriverIndicationStatuses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports